(() => {
  const ROOT = document.documentElement;

  const NAV_NAME = 'navigation';
  const NAV_BTN_SEL  = '[data-js-popup-button="navigation"]';
  const NAV_BODY_SEL = '.popup__body[data-js-popup-name="navigation"]';
  const POPUP_WRAP_SEL = '.popup.js-popup';

  let navBody = null;
  let navWrap = null;

  let obs = null;
  let raf = 0;

  // Scroll lock (uniquement quand la NAV est ouverte)
  let unlockScroll = null;

  const find = () => {
    navBody = document.querySelector(NAV_BODY_SEL);
    navWrap = navBody ? navBody.closest(POPUP_WRAP_SEL) : document.querySelector(POPUP_WRAP_SEL);
  };

  // ✅ IMPORTANT : on teste l’état d’ouverture sur LE BODY navigation, pas sur le wrapper global
  const isNavOpen = () => {
    find();
    if (!navBody) return false;
    return navBody.classList.contains('show') || navBody.classList.contains('visible');
  };

  // ✅ FIX: calcule le bas du header réellement visible (sticky) à partir du bouton NAV
  const getHeaderBottomPx = () => {
    const tape = document.querySelector('.js-header-tape');
    const btn  = document.querySelector(NAV_BTN_SEL);

    let bottom = 0;

    // 1) Tape si visible dans le viewport
    if (tape) {
      const r = tape.getBoundingClientRect();
      if (r.height > 0 && r.bottom > 0) bottom = Math.max(bottom, r.bottom);
    }

    // 2) Header "réel" = ancêtre du bouton burger (celui qui est sticky quand tu scroll)
    if (btn) {
      const headerHost = btn.closest('.header__line-top, .header__content, header, .js-header');
      if (headerHost) {
        const r = headerHost.getBoundingClientRect();
        if (r.height > 0 && r.bottom > 0) bottom = Math.max(bottom, r.bottom);
      }
    }

    bottom = Math.max(0, Math.round(bottom));
    return bottom || 110;
  };

  const updateHeaderVar = () => {
    ROOT.style.setProperty('--cn-header-h', `${getHeaderBottomPx()}px`);
  };

  const setIconOpen = (open) => {
    ROOT.classList.toggle('cn-nav-icon-open', open);
  };

  const setLayoutOpen = (open) => {
    ROOT.classList.toggle('cn-nav-open', open);
  };

  // ✅ Scroll lock PROPRE (iOS safe) : bloque le scroll "derrière"
  // sans casser le scroll à l’intérieur du menu
  const lockScroll = () => {
    if (unlockScroll) return;

    // Track touch pour bloquer le "scroll-chain" iOS
    let startY = 0;
    let lastY = 0;

    const getY = (e) => (e.touches && e.touches[0] ? e.touches[0].clientY : null);

    const onTouchStart = (e) => {
      if (!isNavOpen()) return;
      const y = getY(e);
      if (y == null) return;
      startY = y;
      lastY = y;
    };

    const preventTouchMove = (e) => {
      if (!isNavOpen()) return;

      // Autorise le scroll uniquement DANS le menu navigation
      const inNav = e.target && e.target.closest && e.target.closest(NAV_BODY_SEL);

      // Si on touche hors menu => on bloque tout (page derrière)
      if (!inNav) {
        e.preventDefault();
        return;
      }

      // Si le menu ne scroll pas (contenu trop petit) => on bloque aussi
      if (!navBody) find();
      if (!navBody) {
        e.preventDefault();
        return;
      }

      const y = getY(e);
      if (y == null) return;

      const dy = y - lastY;
      lastY = y;

      const scrollTop = navBody.scrollTop;
      const maxScroll = navBody.scrollHeight - navBody.clientHeight;

      // Pas scrollable => bloque
      if (maxScroll <= 0) {
        e.preventDefault();
        return;
      }

      // ✅ Cas iOS critique : on est en haut et on "tire vers le bas" => sinon ça scroll la page derrière
      if (scrollTop <= 0 && dy > 0) {
        e.preventDefault();
        return;
      }

      // ✅ Cas iOS critique : on est en bas et on "pousse vers le haut" => sinon ça scroll la page derrière
      if (scrollTop >= maxScroll && dy < 0) {
        e.preventDefault();
        return;
      }

      // Sinon : scroll autorisé dans le menu (on ne fait rien)
    };

    const preventWheel = (e) => {
      if (!isNavOpen()) return;
      if (e.target && e.target.closest && e.target.closest(NAV_BODY_SEL)) return;
      e.preventDefault();
    };

    const preventKeys = (e) => {
      if (!isNavOpen()) return;

      const k = e.key;
      const block =
        (k === 'ArrowUp' || k === 'ArrowDown' || k === 'PageUp' || k === 'PageDown' ||
         k === 'Home' || k === 'End' || k === ' ');

      // ne bloque pas la saisie dans un champ
      const tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : '';
      const typing = tag === 'input' || tag === 'textarea' || tag === 'select' || (e.target && e.target.isContentEditable);

      if (block && !typing) e.preventDefault();
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
    document.addEventListener('touchmove', preventTouchMove, { passive: false, capture: true });
    document.addEventListener('wheel', preventWheel, { passive: false, capture: true });
    document.addEventListener('keydown', preventKeys, true);

    unlockScroll = () => {
      document.removeEventListener('touchstart', onTouchStart, { capture: true });
      document.removeEventListener('touchmove', preventTouchMove, { capture: true });
      document.removeEventListener('wheel', preventWheel, { capture: true });
      document.removeEventListener('keydown', preventKeys, true);
      unlockScroll = null;
    };
  };

  const unlockScrollIfAny = () => {
    if (unlockScroll) unlockScroll();
  };

  // ✅ Patch Shella : skip fixBody/unfixBody UNIQUEMENT pour la popup "navigation"
  const patchTheme = () => {
    if (!window.theme || !theme.Global || !theme.Popups) return false;
    if (theme.Global.__cn_nav_patched) return true;

    const Global = theme.Global;
    const Popups = theme.Popups;

    Global.__cn_nav_skip_fix = false;
    Global.__cn_nav_skip_unfix = false;

    const origFix = Global.fixBody;
    const origUnfix = Global.unfixBody;

    Global.fixBody = function (...args) {
      if (Global.__cn_nav_skip_fix) return;
      return origFix.apply(this, args);
    };

    Global.unfixBody = function (...args) {
      // garde-fou : si fixBody n’a pas tourné, on ne “restaure” rien (sinon scroll jump)
      if (this._fixed_scroll_top == null) return;
      if (Global.__cn_nav_skip_unfix) return;
      return origUnfix.apply(this, args);
    };

    const origCall = Popups.callByName;
    Popups.callByName = function (name, $target) {
      if (name === NAV_NAME) {
        Global.__cn_nav_skip_fix = true;
        const res = origCall.apply(this, arguments);
        Global.__cn_nav_skip_fix = false;
        return res;
      }
      return origCall.apply(this, arguments);
    };

    const origClose = Popups.closeByName;
    Popups.closeByName = function (name, $target, cb) {
      if (name === NAV_NAME) {
        Global.__cn_nav_skip_unfix = true;

        // on réactive unfixBody dès que la fermeture est finie
        try {
          if (typeof Popups.addHandler === 'function') {
            Popups.addHandler(NAV_NAME, 'close.after', () => {
              Global.__cn_nav_skip_unfix = false;
            }, 'one');
          } else {
            setTimeout(() => { Global.__cn_nav_skip_unfix = false; }, 800);
          }
        } catch (e) {
          setTimeout(() => { Global.__cn_nav_skip_unfix = false; }, 800);
        }

        return origClose.apply(this, arguments);
      }
      return origClose.apply(this, arguments);
    };

    Global.__cn_nav_patched = true;
    return true;
  };

  const sync = () => {
    find();
    const open = isNavOpen();

    setLayoutOpen(open);
    setIconOpen(open);

    if (open) {
      updateHeaderVar();
      lockScroll();
    } else {
      unlockScrollIfAny();
    }
  };

  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      sync();
    });
  };

  const attachObserver = () => {
    find();
    if (!navBody) return;

    if (obs) obs.disconnect();
    obs = new MutationObserver(schedule);
    obs.observe(navBody, { attributes: true, attributeFilter: ['class'] });
  };

  // ✅ On gère le bouton NAV nous-mêmes pour éviter scroll-top / conflits click
  let blockClickUntil = 0;

  const onNavDown = (e) => {
    const btn = e.target && e.target.closest ? e.target.closest(NAV_BTN_SEL) : null;
    if (!btn) return;

    if (!patchTheme()) return;

    attachObserver();
    updateHeaderVar();

    // bloque les comportements par défaut + le handler click Shella (sinon double actions)
    blockClickUntil = Date.now() + 800;
    e.preventDefault();
    e.stopPropagation();

    const y = window.pageYOffset || 0;

    if (isNavOpen()) {
      theme.Popups.closeByName(NAV_NAME, null);
    } else {
      const $t = window.jQuery ? window.jQuery(btn) : null;
      theme.Popups.callByName(NAV_NAME, $t);
    }

    // garde le scroll stable (couvre iOS focus/anchor)
    setTimeout(() => {
      window.scrollTo(0, y);
      sync();
    }, 0);
  };

  const onClickCapture = (e) => {
    if (Date.now() < blockClickUntil) {
      const btn = e.target && e.target.closest ? e.target.closest(NAV_BTN_SEL) : null;
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  };

  // pointerdown > touchstart (évite double fire)
  if ('PointerEvent' in window) {
    document.addEventListener('pointerdown', onNavDown, true);
  } else {
    document.addEventListener('touchstart', onNavDown, { capture: true, passive: false });
  }
  document.addEventListener('click', onClickCapture, true);

  window.addEventListener('resize', () => {
    if (isNavOpen()) updateHeaderVar();
  }, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      if (isNavOpen()) updateHeaderVar();
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    patchTheme();
    attachObserver();
    updateHeaderVar();
    sync();
  });

  // init best effort
  patchTheme();
  attachObserver();
  updateHeaderVar();
  sync();
})();
